import { isNonEmptyArray } from '@/utils/checks'
import { isPremium } from '@/domain/center'

export const shouldShowCenterHighlights = (center) => {
  return isPremium(center) && isNonEmptyArray(center?.highlights)
}
